// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- -- - --- --- --- --- --- --- --- --- --- ---
// MARK: -  Model Definition
/** Model that describes a user that can be inspected by others.
 * It has only public properties and no sensitive data.
 */
export class InspectableUser {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.email = model.email;
        this.name = model.profile.name;
        this.nickname = (_a = model.profile.nickname) !== null && _a !== void 0 ? _a : null;
        this.avatar = (_b = model.profile.avatar) !== null && _b !== void 0 ? _b : null;
    }
}
